import { render, staticRenderFns } from "./AwardModal.vue?vue&type=template&id=6b45dce7&scoped=true&"
import script from "./AwardModal.vue?vue&type=script&lang=js&"
export * from "./AwardModal.vue?vue&type=script&lang=js&"
import style0 from "./AwardModal.vue?vue&type=style&index=0&id=6b45dce7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b45dce7",
  null
  
)

export default component.exports